var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-container"},[_c(_setup.StreamContainer,{attrs:{"show-room-tool":_vm.showRoomTool},on:{"on-destroy-room":_setup.onDestroyRoom,"on-exit-room":_setup.onExitRoom}}),_c(_setup.RoomSidebar),_c(_setup.RoomModel)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }